import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { styledTypography } from '@pkg/primitives';

interface StyleProps {
    $isHeader?: boolean;
}

export const TABLE_STYLES = css`
    display: grid;
    gap: 5px 5px;
    width: 100%;
`;

export const ListTable = styled.div<StyleProps>`
    ${TABLE_STYLES};
    grid-template-columns: 1fr 80px 25px;
    border-bottom: ${({ $isHeader }) => ($isHeader ? '1px solid #fff' : '1px solid rgba(94, 94, 94, 0.5)')};
`;

export const GameTable = styled.div<StyleProps>`
    ${TABLE_STYLES};
    grid-template-columns: minmax(150px, 4.5fr) repeat(2, 4fr) 3fr;
`;

export const StyledGameRowLink = styled(Link)`
    ${TABLE_STYLES};
    cursor: pointer;
    grid-template-columns: 1fr;

    &:hover {
        opacity: 0.5;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        grid-template-columns: minmax(150px, 4.5fr) repeat(2, 4fr) 3fr;
    }
`;

export const GameTableItem = styled.div<StyleProps>`
    cursor: ${({ $isHeader }) => $isHeader && 'pointer'};
    padding: ${({ $isHeader }) => ($isHeader ? '0 10px 10px' : '5px')};
    color: ${({ theme }) => theme.shades.white[80]};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: wrap;

    ul {
        margin: 0;
        padding: 0 0 0 15px;
    }
    p {
        display: flex;
        justify-content: space-between;
        margin: 0;
        line-height: 1.1;
        color: ${({ theme }) => theme.shades.white[60]};
        font-size: 15px;
        cursor: ${({ $isHeader }) => $isHeader && 'pointer'};
    }
    span {
        font-weight: 700;
    }

    strong {
        ${styledTypography.truncate};
        max-width: 100%;
    }
`;

export const NameContentWrapper = styled.div`
    ${styledTypography.truncate};
    width: max-content;
`;

export const DescriptionWrapper = styled.div`
    padding: 5px 0;
    font-size: 14px;
    color: ${({ theme }) => theme.shades.white[80]};
`;
export const ActionsWrapper = styled.div`
    gap: 5px;
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
    justify-content: center;
    font-size: 12px;
`;

export const DeleteWrapper = styled.div`
    width: 160px;
    top: 160px;
    position: absolute;
    right: 30px;
`;
